import bgCarier from '../../assets/img/hero/bg-carier.png';
import Attention from "../../components/carier/Attention";
import Content from "../../components/carier/Content";
import Hero from '../../components/carier/Hero';
import Footer from "../../components/shared/Footer";
import Navbar from '../../components/shared/Navbar';


export default function Carier() {
    return (
        <div className="flex flex-col min-h-screen">
            <Attention />
            <div className="relative">
                <div>
                    <Navbar></Navbar>
                    <Hero></Hero>
                </div>
                <main className="flex-grow">
                    <Content />

                </main>
            </div>
            <Footer />
        </div>
    );
}
